(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-announcement-bar][data-dismissible]');
    if (!bar) return;
    var storageKey = 'dct-announcement-dismissed-' + bar.getAttribute('data-key');
    if (localStorage.getItem(storageKey) === '1') {
      bar.hidden = true;
      return;
    }
    var btn = bar.querySelector('[data-announcement-dismiss]');
    if (btn) {
      btn.addEventListener('click', function () {
        bar.hidden = true;
        try { localStorage.setItem(storageKey, '1'); } catch (e) {}
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-nav-toggle]'));
    if (!toggles.length) return;

    function closeAll(except) {
      toggles.forEach(function (btn) {
        if (btn === except) return;
        btn.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
    }

    toggles.forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var wasOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        btn.setAttribute('aria-expanded', String(!wasOpen));
        panel.hidden = wasOpen;
        if (!wasOpen) {
          var firstLink = panel.querySelector('a');
          if (firstLink) firstLink.focus();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      toggles.forEach(function (btn) {
        if (btn.getAttribute('aria-expanded') === 'true') {
          btn.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
          btn.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      toggles.forEach(function (btn) {
        if (btn.getAttribute('aria-expanded') === 'true' && !btn.parentElement.contains(e.target)) {
          btn.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  /* Liquid is NOT rendered inside a javascript block — see the same note in
     sections/main-product.liquid. The old getElementById used an un-rendered Liquid tag, so
     neither the facets auto-submit nor the grid-density toggle has ever worked. */
  (function (boot) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
  })(function () {
    var root = document.querySelector('[data-collection-root]');
    if (!root) return;

    /* Progressive enhancement only: auto-submit the facets form on change. The Apply button
       already makes this fully functional without JS. */
    var form = root.querySelector('[data-facets-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select[data-facets-sort]')) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    }

    /* Grid density toggle, persisted in localStorage. */
    var toggle = root.querySelector('[data-density-toggle]');
    var grid = root.querySelector('[data-product-grid]');
    if (toggle && grid) {
      var KEY = 'dct:density';
      var apply = function (n) {
        grid.style.setProperty('--cols-lg', n);
        Array.prototype.forEach.call(toggle.querySelectorAll('[data-density]'), function (btn) {
          btn.setAttribute('aria-pressed', btn.getAttribute('data-density') === String(n) ? 'true' : 'false');
        });
        try { window.localStorage.setItem(KEY, n); } catch (e) {}
      };
      var stored = null;
      try { stored = window.localStorage.getItem(KEY); } catch (e) {}
      if (stored === '3' || stored === '4') apply(stored);

      toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-density]');
        if (!btn) return;
        apply(btn.getAttribute('data-density'));
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* Liquid is NOT rendered inside a javascript block. Shopify compiles this file once, for
     every section of this type, into compiled_assets/scripts.js — so a Liquid tag arrives
     here as literal text. The old lookup was getElementById('pdp-' + the raw, un-rendered
     tag), which never matched, so nothing below this line has ever run: variant switching,
     the gallery counter and both size tools were all dead. The root is now found by a data
     attribute on the section, and the whole thing waits for the DOM.
     (One product section per page, so a single querySelector is enough.) */
  (function (boot) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
  })(function () {
    var root = document.querySelector('[data-pdp-root]');
    if (!root) return;

    var dataEl = root.querySelector('[data-variant-data]');
    var data = {};
    try { data = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) { data = {}; }

    /* ------------------------------------------------- Reference panels
       REMOVED 2026-09-15 (round 2): the three accordions used to be forced OPEN on desktop,
       because they sat in the right-hand column and that column ended ~1550px above the
       bottom of the gallery, leaving the right half of the screen empty. They now sit full
       width under the description, where there is no hole to fill, and three panels opened
       by script under a description is exactly the wall of text the 2026-09-14 rebuild took
       out. They are closed everywhere and the customer opens what he wants. */

    var priceEl = root.querySelector('[data-price]');
    var stockEl = root.querySelector('[data-stock-line]');
    var form = root.querySelector('[data-add-to-cart]');
    var addBtn = form ? form.querySelector('[data-add-button]') : null;
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var strings = (window.DCT && window.DCT.strings) || {};
    var expressRow = root.querySelector('[data-express-row]');
    var errEl = root.querySelector('[data-add-error]');
    var tSelectASize = root.getAttribute('data-t-select-a-size') || '';

    /* ------------------------------------------------------------- Quantity
       The stepper is not rendered on the product page any more, so every lookup
       below can come back null. Each branch is guarded: the code stays because
       the same section type is used wherever the picker IS rendered, and the
       sticky bar still echoes a quantity above one.

       No money arithmetic happens in here. Every figure printed was formatted
       by Liquid and shipped inside [data-variant-data]; this code picks a
       finished string out of it. Same rule as the price HTML above. */
    var qtyField = root.querySelector('[data-qty-field]');
    var qtyInput = qtyField ? qtyField.querySelector('[data-qty-input]') : null;
    var qtySaving = qtyField ? qtyField.querySelector('[data-qty-saving]') : null;
    var qtyStock = qtyField ? qtyField.querySelector('[data-qty-stock]') : null;
    var qtySteps = qtyField ? Array.prototype.slice.call(qtyField.querySelectorAll('[data-qty-step]')) : [];
    var stickyQty = root.querySelector('[data-sticky-qty]');

    function qtyTemplate(name) {
      return qtyField ? (qtyField.getAttribute('data-t-' + name) || '') : '';
    }

    /* The picker writes the variant id into name="id" three different ways
       depending on how many options the product has (checked radio, native
       select, or a hidden input). Read whichever is actually there rather than
       tracking selection separately — the form is the single source of truth
       for what is about to be added. */
    function selectedVariant() {
      if (!form) return null;
      var el = form.querySelector('input[name="id"]:checked') ||
               form.querySelector('select[name="id"]') ||
               form.querySelector('input[name="id"]');
      return el ? (data[el.value] || null) : null;
    }

    /* clamp=false while the customer is still typing: the ceiling is reflected
       in the buttons and the saving line, but the field is left alone. Rewriting
       a half-typed value under the cursor turns "delete, type 12" into "112". */
    function syncQty(clamp) {
      if (!qtyInput) return;
      var v = selectedVariant();
      var max = (v && v.max) ? v.max : parseInt(qtyInput.getAttribute('max'), 10);
      if (!max || max < 1) max = 1;
      qtyInput.setAttribute('max', max);

      var q = parseInt(qtyInput.value, 10);
      if (isNaN(q) || q < 1) q = 1;
      if (q > max) q = max;
      if (clamp && String(q) !== qtyInput.value) qtyInput.value = q;

      qtySteps.forEach(function (b) {
        var d = parseInt(b.getAttribute('data-qty-step'), 10);
        b.disabled = (d < 0 && q <= 1) || (d > 0 && q >= max);
      });

      if (qtySaving) {
        var s = (v && v.savings) ? v.savings[String(q)] : null;
        if (s && s.pct > 0) {
          qtySaving.textContent = qtyTemplate('saving')
            .replace('§P§', s.pct)
            .replace('§A§', s.amount);
          qtySaving.hidden = false;
        } else {
          qtySaving.textContent = '';
          qtySaving.hidden = true;
        }
      }

      /* Only a genuinely tracked, oversell-refusing variant may say a stock
         number out loud. The section's own max_quantity cap is a typo guard,
         not a fact about the warehouse, so when THAT is the ceiling being hit
         this line stays silent rather than inventing scarcity. */
      if (qtyStock) {
        if (v && v.tracked && q >= max) {
          qtyStock.textContent = qtyTemplate('stock').replace('§N§', max);
          qtyStock.hidden = false;
        } else {
          qtyStock.textContent = '';
          qtyStock.hidden = true;
        }
      }

      /* The sticky bar submits this same form via its form="" attribute, so it
         already sends the chosen quantity. Echoing it keeps the bar honest
         about what its button is going to do. */
      if (stickyQty) stickyQty.textContent = q > 1 ? '× ' + q : '';
    }

    if (qtyInput) {
      qtyField.addEventListener('click', function (e) {
        var step = e.target.closest('[data-qty-step]');
        if (!step) return;
        var n = parseInt(qtyInput.value, 10);
        if (isNaN(n)) n = 1;
        qtyInput.value = n + parseInt(step.getAttribute('data-qty-step'), 10);
        syncQty(true);
      });
      qtyInput.addEventListener('input', function () { syncQty(false); });
      qtyInput.addEventListener('change', function () { syncQty(true); });
      /* Last line of defence: a typed-over-the-ceiling value that never lost
         focus. This listener sits on the form itself, so it runs before the
         delegated submit handler in theme.js builds its FormData. */
      if (form) form.addEventListener('submit', function () { syncQty(true); });
      syncQty(true);
    }

    function applyVariant(id) {
      var v = data[id];
      if (!v) return;
      if (priceEl && v.priceHtml) priceEl.innerHTML = v.priceHtml;
      if (stockEl) {
        if (v.stockText) { stockEl.textContent = v.stockText; stockEl.hidden = false; }
        else { stockEl.hidden = true; stockEl.textContent = ''; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.toggleAttribute('aria-disabled', !v.available);
      }
      if (addLabel) addLabel.textContent = v.available ? (strings.addToBag || addLabel.textContent) : (strings.soldOut || addLabel.textContent);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }
      /* A different size can have a different tracked ceiling and a different
         price, so the quantity field and its saving line both have to follow
         the switch. Without this, picking a size left the old saving on screen. */
      syncQty(true);
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-variant-radio]')) return;
      applyVariant(e.target.value);
      updateExpressForSize();
    });

    /* --------------------------------------------- No size chosen (cro-kade-pdp §A3)
       Whether the currently visible size control has a real (non-blank) value. Works for
       both shapes this theme renders a size control in: a fieldset of radios (colour + size
       products, snippets/variant-picker.liquid — one pre-rendered [data-size-group] per
       colour, only one ever visible) and a native <select data-size-required> (the bundle
       selector's tier-1 row, and variant-picker's 3+-option fallback). A product with no size
       option at all (colour-only, or truly one variant) has neither, and counts as "chosen" —
       see "Products WITHOUT a size option... must behave exactly as now" in the brief. */
    function sizeChosenInForm(scopeForm) {
      var fs = root.querySelector('[data-size-field]');
      if (fs) {
        var scope = fs.querySelector('[data-size-group]:not([hidden])') || fs;
        return !!scope.querySelector('input[type="radio"]:checked');
      }
      var sel = scopeForm ? scopeForm.querySelector('select[data-size-required]:not([disabled])') : null;
      if (sel) return sel.value !== '';
      return true;
    }

    /* The express wallet row must never be usable before a real size is chosen — it would
       otherwise check out whatever variant the FORM currently names, which without a size
       choice is just the fallback current_variant. Bundle tiers 2/3 are not this concern:
       snippets/bundle-ladder.liquid's own script owns the row for as long as one of them is
       selected, and this function steps aside for it (same "only ever force off" rule). */
    function updateExpressForSize() {
      if (!expressRow) return;
      var bselRoot = root.querySelector('[data-bsel]');
      if (bselRoot) {
        var checkedTier = bselRoot.querySelector('[data-bsel-radio]:checked');
        if (checkedTier && checkedTier.value !== '1') return;
      }
      expressRow.hidden = !sizeChosenInForm(form);
    }
    updateExpressForSize();

    /* The real guard: pressing Add (or the mobile sticky bar, which submits this same form
       via its form="" attribute) without a size must never add the fallback variant.
       cro-kade-pdp herstel 1, item 3/14: bundle-ladder.liquid's own submit listener already
       refuses an incomplete row for EVERY tier, tier 1 included (its own tier1SizeChosen()
       check) — this guard used to also run for tier 1 on a bundle product, so an
       incomplete size painted both files' error message at once, ~250px apart, and raced
       bundle-ladder's own scroll/focus. Step aside completely whenever a bundle selector
       owns this form; this guard is only for the plain picker (no bundle ladder). */
    if (form) {
      form.addEventListener('submit', function (e) {
        var bselRoot = root.querySelector('[data-bsel]');
        if (bselRoot) return;
        if (sizeChosenInForm(form)) return;
        e.preventDefault();
        e.stopPropagation();
        if (errEl && tSelectASize) {
          errEl.textContent = tSelectASize;
          errEl.hidden = false;
        }
        var target = root.querySelector('[data-size-field] [data-size-group]:not([hidden])') ||
                     root.querySelector('[data-size-field]') ||
                     form.querySelector('select[data-size-required]:not([disabled])');
        if (target) {
          if (target.scrollIntoView) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var focusEl = target.matches('select') ? target : target.querySelector('input[type="radio"]');
          if (focusEl && focusEl.focus) focusEl.focus();
        }
      });
    }

    /* ------------------------------------------------- Colour swap (cro-kade-pdp §A2)
       The colour swatches are real <a href="?variant=…"> links (both the standalone picker
       and the bundle selector's tier-1 row share this exact markup, [data-colour-link]), so a
       no-JS visitor still gets a full, honest reload. Here the click is intercepted and the
       same result is produced client-side: price/stock/button/URL via the applyVariant() this
       file already had for the size radios, plus the colour name, the swatch selection state,
       the matching gallery photo, and the pre-rendered size control for the NEW colour — never
       rebuilt in JS, every colour's size options already exist in the markup (one block per
       colour), this only toggles which one is visible/enabled. */
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-colour-link]');
      if (!link) return;
      var vid = link.getAttribute('data-variant-id');
      if (!vid || !data[vid]) return; // no client-side data for this link: let the honest reload happen
      e.preventDefault();

      applyVariant(vid);
      if (errEl) errEl.hidden = true;

      var newColour = link.getAttribute('data-colour-value');
      var group = link.closest('[role="group"]');
      if (group) {
        group.querySelectorAll('[data-colour-link]').forEach(function (a) {
          var isThis = a === link;
          a.classList.toggle('is-selected', isThis);
          if (isThis) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
        var nameEl = group.parentElement ? group.parentElement.querySelector('[data-colour-name]') : null;
        if (nameEl && newColour) nameEl.textContent = newColour;
      }

      var mediaId = link.getAttribute('data-media-id');
      if (mediaId) {
        var slide = root.querySelector('.pdp-gallery__item[data-media-id="' + mediaId + '"]');
        var trackEl = root.querySelector('[data-gallery-track]');
        /* cro-kade-pdp herstel 1, item 2/12: scrollIntoView({block:'nearest'}) also moves
           the PAGE vertically back up to the gallery the instant the gallery has scrolled
           out of the viewport (measured: 1162px -> 187px on mobile, a ~6978px jump on
           desktop) — it does not know that the gallery's own horizontal track is the thing
           that should move. Scroll that track directly instead. On desktop >=1100px the
           track has no horizontal overflow (see .pdp-gallery__track in the >=1100px block
           above), so this call is a no-op there and the page is never touched either way. */
        var isDesktopGallery = window.matchMedia && window.matchMedia('(min-width: 1100px)').matches;
        if (isDesktopGallery && slide && trackEl && trackEl.contains(slide)) {
          /* laatste herstel (2026-09-24), item 1: the scrollTo fix above left the desktop
             gallery showing the PREVIOUS colour's photo, because scrollTo really is a
             no-op there (no horizontal overflow to move) — nothing ever brought the new
             colour's shot to where the customer is looking. The desktop track is a plain
             vertical flex column (see the >=1100px block above), so moving the chosen
             slide to the FIRST child reorders it to the top without scrolling anything:
             every slide shares one fixed aspect-ratio box, so the track's total height —
             and therefore the page's scroll position — never changes. A slide moved up
             from far down the column may still be `loading="lazy"` and holding its
             data-src/data-srcset (see product-gallery.liquid's `defer`), so force it to
             load now with the same helper the swipe/scroll observer below already uses. */
          if (trackEl.firstElementChild !== slide) trackEl.insertBefore(slide, trackEl.firstElementChild);
          Array.prototype.forEach.call(slide.querySelectorAll('[data-defer-img]'), function (img) {
            img.loading = 'eager';
            revealDeferredImg(img);
          });
        } else if (slide && trackEl && trackEl.contains(slide) && trackEl.scrollTo) {
          var delta = slide.getBoundingClientRect().left - trackEl.getBoundingClientRect().left;
          trackEl.scrollTo({ left: trackEl.scrollLeft + delta, behavior: 'smooth' });
        } else if (slide && slide.scrollIntoView) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }

      if (newColour) {
        var sizeFieldset = root.querySelector('[data-size-field]');
        if (sizeFieldset) {
          sizeFieldset.querySelectorAll('[data-size-group]').forEach(function (g) {
            g.hidden = g.getAttribute('data-size-group') !== newColour;
          });
        }
        if (form) {
          var perColourSels = form.querySelectorAll('select[data-size-for-colour]');
          if (perColourSels.length) {
            perColourSels.forEach(function (s) {
              var isNew = s.getAttribute('data-size-for-colour') === newColour;
              s.hidden = !isNew;
              s.disabled = !isNew;
              if (isNew) { s.setAttribute('name', 'id'); s.value = ''; }
              else { s.removeAttribute('name'); }
            });
          } else if (!sizeFieldset) {
            /* cro-kade-pdp herstel 1, item 10: a colour-only product (no size option at
               all) has a single plain hidden name="id" input, server-rendered to the
               default variant and never written to by this handler before —
               applyVariant() above already made the price/stock/URL look right, but the
               field /cart/add actually reads still held the ORIGINAL colour, so the wrong
               item reached the cart every time a shopper switched colour and added. */
            var idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = vid;
          }
        }
      }

      updateExpressForSize();
    });

    /* ----------------------------------------- Cross-sell size guard (laatste herstel, item 2)
       snippets/pdp-cross-sell.liquid's "Complétez le look" cards used to pre-select the shop's
       fallback variant in their flat <select name="id"> — for a SIZED product (data-size-select,
       set only when the card's option is not colour-like) that meant AJOUTER silently added a
       size nobody chose, the opposite of this store's own §A3 rule. The select itself now
       renders with no pre-selection and a blank "choose a size" option (see that file); this
       guard blocks the card's own submit the same way the plain picker above blocks the main
       form, and reuses the exact same translation string and its own already-present
       [data-add-error] slot right under the button. A colour-only or single-variant card has no
       [data-size-select] and is left exactly as it was. */
    root.querySelectorAll('.xsell__form').forEach(function (xform) {
      var xsel = xform.querySelector('select[data-size-select]');
      if (!xsel) return;
      var xerr = xform.querySelector('[data-add-error]');
      xform.addEventListener('submit', function (e) {
        if (xsel.value !== '') return;
        e.preventDefault();
        e.stopPropagation();
        if (xerr && tSelectASize) { xerr.textContent = tSelectASize; xerr.hidden = false; }
        if (xsel.scrollIntoView) xsel.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (xsel.focus) xsel.focus();
      });
      xsel.addEventListener('change', function () {
        if (xerr) xerr.hidden = true;
      });
    });

    /* Gallery position. The visible cue is the dash strip drawn ON the photograph
       (.pdp-gallery__dots). The "Image X of Y" sentence still exists but is now
       visually-hidden: the operator asked for the printed caption to go, not for
       the information to disappear from assistive technology. */
    var track = root.querySelector('[data-gallery-track]');
    var counter = root.querySelector('[data-gallery-counter]');

    /* Reveals one deferred slide's real src/srcset. Shared by the load-on-swipe observer
       below and by the load-event fallback that follows it, so there is one place that
       knows how a deferred image gets filled in. Safe to call twice: once data-src/
       data-srcset are consumed they are removed, so a second call is a no-op. */
    function revealDeferredImg(img) {
      var picture = img.closest('picture');
      if (picture) {
        Array.prototype.forEach.call(picture.querySelectorAll('source[data-srcset]'), function (src) {
          src.srcset = src.getAttribute('data-srcset');
          src.removeAttribute('data-srcset');
        });
      }
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
      if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
    }

    if (track && 'IntersectionObserver' in window) {
      var items = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-item]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
      /* root: null (the viewport), not root: track — a plain IntersectionObserver still
         respects an ancestor's overflow clipping, so this reads correctly on a phone
         (track is a real horizontal scroller, overflow-x: auto) AND on desktop >= 1100px
         (track becomes a vertical, non-scrolling column: overflow: visible, display:
         flex/column — see the DESKTOP media query above). root: track broke exactly there:
         a non-scrolling track has no clipping box for the observer to measure against, so
         Chromium reported every slide as already intersecting and this script revealed all
         ten at once (measured: 16 images / 4.24MB on desktop vs V9's 9 / 1.14MB). */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = items.indexOf(entry.target);
            if (idx < 0) return;
            dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
            if (counter) {
              var tpl = counter.getAttribute('data-template') || '';
              counter.textContent = tpl.replace('§I§', idx + 1);
            }
          }
        });
      }, { root: null, threshold: [0.6] });
      items.forEach(function (el) { io.observe(el); });

      /* 2026-09-22, ronde 5: load a deferred gallery slide (see snippets/product-gallery.liquid
         and snippets/responsive-image.liquid's `defer` param) once it is about to be swiped into
         view (phone) or scrolled into view (desktop), not when it merely sits somewhere on the
         page. This is a SEPARATE observer from the dot-sync one above on purpose: widening that
         one's rootMargin to pre-load early would also move its 0.6-ratio dot-switch point earlier
         and desync the dash strip from what is actually centred. rootMargin extends the viewport
         by one slide-width left/right (phone swipe-ahead) and 200px top/bottom (desktop
         scroll-ahead), so the next slide starts downloading just before it is reached instead of
         all at once with the hero — that simultaneous download (~725KB across 4 slides on phone)
         is what the phoneslow measurement (wf-phoneslow-1.json) showed competing with the hero
         photo for bandwidth. */
      var loadIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          Array.prototype.forEach.call(entry.target.querySelectorAll('[data-defer-img]'), revealDeferredImg);
          loadIO.unobserve(entry.target);
        });
      }, { root: null, rootMargin: '200px 100% 200px 100%', threshold: 0.01 });
      items.forEach(function (el) { loadIO.observe(el); });
    }

    /* The load-event fallback used to sit here. It now lives in its own <script> tag
       right after </section> above, OUTSIDE this compiled block, so it still runs when
       this bundle itself fails to load. See that tag's comment for why. */

    /* ---------------------------------------------------------------- Size finder
       Reads ONLY this product's own chart (custom.size_chart). It never interpolates
       past the chart, never falls back to a generic table, and never quietly picks one
       side of a straddle. Every branch that cannot answer says so and points at the
       measurements instead. */
    var finder = root.querySelector('[data-size-finder]');
    var dataEl2 = root.querySelector('[data-sf-data]');
    if (finder && dataEl2) {
      var SF = {};
      try { SF = JSON.parse(dataEl2.textContent); } catch (e) { SF = null; }

      if (SF && SF.heights && SF.bands && SF.grid) {
        var out = finder.querySelector('[data-sf-result]');
        var t = function (name) { return finder.getAttribute('data-t-' + name) || ''; };

        /* Metric <-> imperial. Conversions are exact; the metric figure actually used
           is always shown back to the customer so nothing is hidden in a rounding. */
        var toCm = function (ft, inch) { return (ft * 12 + inch) * 2.54; };
        var toKg = function (st, lb) { return (st * 14 + lb) * 0.45359237; };

        finder.querySelectorAll('[data-sf-units]').forEach(function (r) {
          r.addEventListener('change', function () {
            var imp = r.value === 'imperial' && r.checked;
            finder.querySelector('[data-sf-metric]').hidden = imp;
            finder.querySelector('[data-sf-imperial]').hidden = !imp;
            out.innerHTML = '';
          });
        });

        var num = function (sel) {
          var el = finder.querySelector(sel);
          if (!el || el.value === '') return null;
          var v = parseFloat(el.value);
          return isNaN(v) ? null : v;
        };

        var say = function (html) { out.innerHTML = html; };
        var esc = function (s) {
          return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          });
        };

        finder.querySelector('[data-sf-go]').addEventListener('click', function () {
          var imperial = !finder.querySelector('[data-sf-imperial]').hidden;
          var cm, kg;

          if (imperial) {
            var ft = num('[data-sf-ft]'), inch = num('[data-sf-in]') || 0;
            var st = num('[data-sf-st]'), lb = num('[data-sf-lb]') || 0;
            if (ft === null || st === null) { say('<span class="finder__why">' + esc(t('incomplete')) + '</span>'); return; }
            cm = Math.round(toCm(ft, inch));
            kg = Math.round(toKg(st, lb));
          } else {
            cm = num('[data-sf-cm]');
            kg = num('[data-sf-kg]');
            if (cm === null || kg === null) { say('<span class="finder__why">' + esc(t('incomplete')) + '</span>'); return; }
          }

          /* Row: nearest charted height. The chart's rows are sample heights, so rounding
             to the nearest is what the maker intends — but only inside the chart. More than
             half a step beyond either end is off the chart, and we say so. */
          var hs = SF.heights.slice().sort(function (a, b) { return a - b; });
          var step = hs.length > 1 ? (hs[1] - hs[0]) : 5;
          if (cm < hs[0] - step || cm > hs[hs.length - 1] + step) {
            say('<span class="finder__why">' + esc(t('off')) + '</span>'); return;
          }
          var rowIdx = 0, best = Infinity;
          hs.forEach(function (h, i) {
            var d = Math.abs(h - cm);
            if (d < best) { best = d; rowIdx = i; }
          });
          rowIdx = SF.heights.indexOf(hs[rowIdx]);

          /* Column: the weight band containing this weight. Bands have deliberate gaps
             (60-65, 75-80). A weight in a gap is answered from BOTH neighbouring bands —
             if they agree we use it, if they differ we show both rather than choose. */
          var cols = [];
          SF.bands.forEach(function (b, i) { if (kg >= b[0] && kg <= b[1]) cols.push(i); });
          if (!cols.length) {
            for (var i = 0; i < SF.bands.length - 1; i++) {
              if (kg > SF.bands[i][1] && kg < SF.bands[i + 1][0]) { cols = [i, i + 1]; break; }
            }
          }
          if (!cols.length) { say('<span class="finder__why">' + esc(t('off')) + '</span>'); return; }
          var row = SF.grid[rowIdx] || [];
          var cells = cols.map(function (c) { return row[c]; }).filter(function (v) {
            return v !== null && v !== undefined && v !== '' && v !== '-' && v !== '–';
          });
          if (!cells.length) { say('<span class="finder__why">' + esc(t('nocell')) + '</span>'); return; }

          /* A cell may itself be a straddle ("S-M"). Collect every distinct size the chart
             offers for this customer, in chart order, and never silently drop one. */
          var sizes = [];
          cells.forEach(function (cell) {
            String(cell).split(/[–—\/-]/).forEach(function (s) {
              s = s.trim();
              if (s && sizes.indexOf(s) === -1) sizes.push(s);
            });
          });

          var headline, why;
          if (sizes.length === 1) {
            headline = t('result').replace('§S§', sizes[0]);
            why = '';
          } else {
            headline = t('between').replace('§A§', sizes[0]).replace('§B§', sizes[sizes.length - 1]);
            why = t('between-note').replace('§A§', sizes[0]).replace('§B§', sizes[sizes.length - 1]);
          }

          var computed = t('computed').replace('§H§', cm).replace('§W§', kg);

          /* Never recommend something this product does not actually sell. */
          var warn = '';
          var stocked = SF.stocked || [];
          if (stocked.length) {
            var missing = sizes.filter(function (s) {
              return !stocked.some(function (v) { return String(v).trim().toUpperCase() === s.toUpperCase(); });
            });
            if (missing.length) warn = t('nostock').replace('§S§', missing.join(', '));
          }

          say(
            '<span class="finder__size">' + esc(headline) + '</span>' +
            (why ? '<span class="finder__why">' + esc(why) + '</span>' : '') +
            '<span class="finder__why">' + esc(computed) + '</span>' +
            (warn ? '<span class="finder__warn">' + esc(warn) + '</span>' : '')
          );
        });
      }
    }

    /* ------------------------------------------------ Compare with a garment you own
       No product in this catalogue publishes a height/weight matrix, and garment
       centimetres cannot be turned into one without inventing the relationship. So this
       answers the same question from the data the maker DOES publish: which charted size
       is closest to a garment the customer already owns and already likes. It is the
       comparison the product description already asks for, done arithmetically.
       The difference in centimetres is ALWAYS shown, never hidden behind a verdict. */
    var match = root.querySelector('[data-size-match]');
    var dataEl3 = root.querySelector('[data-mm-data]');
    if (match && dataEl3) {
      var MM = null;
      try { MM = JSON.parse(dataEl3.textContent); } catch (e) { MM = null; }

      if (MM && MM.tables && MM.tables.length) {
        var mOut = match.querySelector('[data-mm-result]');
        var mt = function (name) { return match.getAttribute('data-t-' + name) || ''; };
        var mEsc = function (s) {
          return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          });
        };
        /* Cells are verbatim from the maker, e.g. "108 (42.5)" — cm first, inches in
           brackets. The leading number is the centimetre figure the label promises. */
        var mNum = function (cell) {
          var v = parseFloat(String(cell).replace(',', '.'));
          return isNaN(v) ? null : v;
        };

        match.querySelector('[data-mm-go]').addEventListener('click', function () {
          var pick = (match.querySelector('[data-mm-col]').value || '').split(':');
          var tbl = MM.tables[parseInt(pick[0], 10)];
          var col = parseInt(pick[1], 10);
          var ownEl = match.querySelector('[data-mm-cm]');
          var own = ownEl && ownEl.value !== '' ? parseFloat(ownEl.value) : NaN;

          if (!tbl || isNaN(col) || isNaN(own)) {
            mOut.innerHTML = '<span class="finder__why">' + mEsc(mt('incomplete')) + '</span>';
            return;
          }

          /* A row with no figure in this column is skipped, never filled in. */
          var pts = [];
          (tbl.rows || []).forEach(function (r) {
            var v = mNum(r[col]);
            if (v !== null) pts.push({ size: r[0], v: v });
          });
          if (pts.length < 2) {
            mOut.innerHTML = '<span class="finder__why">' + mEsc(mt('nonumbers')) + '</span>';
            return;
          }

          var best = pts[0];
          pts.forEach(function (p) { if (Math.abs(p.v - own) < Math.abs(best.v - own)) best = p; });

          /* The largest gap between two neighbouring sizes on this measurement is one
             "size step". Further than that from the whole chart and we say so rather
             than dressing a poor match up as an answer. */
          var stepMax = 0;
          for (var k = 1; k < pts.length; k++) {
            stepMax = Math.max(stepMax, Math.abs(pts[k].v - pts[k - 1].v));
          }

          var diff = Math.round((best.v - own) * 10) / 10;
          var line;
          if (diff === 0) { line = mt('same'); }
          else if (diff > 0) { line = mt('larger').replace('§D§', diff); }
          else { line = mt('smaller').replace('§D§', Math.abs(diff)); }
          line = line.replace('§L§', tbl.columns[col]).replace('§C§', best.v).replace('§O§', own);

          var far = (stepMax && Math.abs(diff) > stepMax) ? mt('far') : '';

          /* Never point at a size this product does not actually sell. */
          var warn = '';
          var stocked = MM.stocked || [];
          if (stocked.length) {
            var inStock = stocked.some(function (v) {
              return String(v).trim().toUpperCase() === String(best.size).trim().toUpperCase();
            });
            if (!inStock) warn = mt('nostock').replace('§S§', best.size);
          }

          mOut.innerHTML =
            '<span class="finder__size">' + mEsc(mt('result').replace('§S§', best.size)) + '</span>' +
            '<span class="finder__why">' + mEsc(line) + '</span>' +
            (far ? '<span class="finder__why">' + mEsc(far) + '</span>' : '') +
            '<span class="finder__why">' + mEsc(mt('caveat')) + '</span>' +
            (warn ? '<span class="finder__warn">' + mEsc(warn) + '</span>' : '');
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
